// VoK MUI base styles
import boxShadows from "app/assets/theme-dark/base/boxShadows";
import typography from "app/assets/theme-dark/base/typography";
import colors from "app/assets/theme-dark/base/colors";
import borders from "app/assets/theme-dark/base/borders";

// VoK MUI helper functions
import pxToRem from "app/assets/theme-dark/functions/pxToRem";

const {lg} = boxShadows;
const {size} = typography;
const {text, background} = colors;
const {borderRadius} = borders;

const menu = {
    defaultProps: {
        disableAutoFocusItem: true,
    },

    styleOverrides: {
        paper: {
            minWidth: pxToRem(160),
            boxShadow: lg,
            padding: `${pxToRem(16)} ${pxToRem(8)}`,
            fontSize: size.sm,
            color: text.main,
            textAlign: "left",
            backgroundColor: `${background.dark} !important`,
            borderRadius: borderRadius.md,
        },
    },
};

export default menu;
